/**
 * Doofinder — thema-kant runtime
 * ───────────────────────────────────────────────────────────────
 *  1. Detectie: zodra de Doofinder Layer geladen is → <html>.doofinder-active
 *     (native predictive-dropdown verbergen + focus/typ overdragen).
 *  2. Mobiel: Doofinder opent betrouwbaar via een ECHTE gebonden zoekinput
 *     (#df-mobile-search). Secundaire triggers (hero faux-bar, bottom-nav
 *     zoek-icoon) routeren we naar diezelfde input i.p.v. de native <dialog>
 *     (die als top-layer modal ÓVER Doofinder rendert). Geen ongedocumenteerde
 *     hash/JS-open meer. Is Doofinder niet actief → native dialoog (fallback).
 */
(function () {
  var cfg = window.DoofinderTheme;
  if (!cfg || !cfg.enabled) return;
  var html = document.documentElement;

  function doofinderLoaded() {
    try {
      if (cfg.loadedSelector && document.querySelector(cfg.loadedSelector)) return true;
    } catch (e) {}
    return !!(window.doofinderApp || window.doofinderLoader || window.dfClassicLayers ||
              window.doofinder || window.dfLayer || window.df_loader);
  }

  function activate() {
    if (!html.classList.contains('doofinder-active')) html.classList.add('doofinder-active');
  }

  // Open Doofinder door de gebonden zoekinput te focussen/klikken
  // (officieel ondersteund: gebruikersinteractie op het CSS-selector-element).
  // Het thema heeft meerdere gebonden zoekinputs: #df-desktop-search,
  // #df-mobile-search en het /search-formulier. Alleen de ZICHTBARE is bruikbaar,
  // want focus op een verborgen input doet niets en opent de zoeklaag niet. De
  // oude code pakte altijd eerst #df-mobile-search, die op desktop verborgen is.
  function boundSearchInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#df-mobile-search, #df-desktop-search, input[name="q"]'));
  }

  function boundSearchInput() {
    var m = document.getElementById('df-mobile-search');
    if (m && m.offsetParent) return m;   // mobiel: de betrouwbaar gebonden input
    var list = boundSearchInputs();
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent) return list[i];
    return m || list[0] || null;
  }

  // Vorige zoekterm selecteren zodra WIJ de zoekbalk openen (2026-08-11)
  //
  // De zoekinput houdt zijn waarde vast: op /search rendert het thema de vorige
  // term in het veld en de zoeklaag onthoudt de laatste query. Wie daarna via het
  // zoekicoon een NIEUWE term typt, plakt die achter de oude. Zo ontstaat
  // "watertest" + "koivoer" = "watertestkoivoer": 0 resultaten. In de no-result
  // stats over 30 dagen staan precies zulke aaneengeplakte queries -
  // watertestkoivoer, luchtpompfontein, koicafebatterij, koicafeloodaccu,
  // epschepnetnet, windesscrimp - samen circa 50 events van klanten die twee keer
  // achter elkaar zochten en niets vonden.
  //
  // We WISSEN de waarde niet: die blijft zichtbaar zodat verfijnen mogelijk blijft.
  // We selecteren hem, zodat typen hem vervangt en Backspace hem wist. Zodra de
  // klant zelf typt stoppen we meteen, en we doen dit alleen op onze eigen
  // open-triggers - niet wanneer iemand in de tekst tikt om te bewerken.
  function selectExistingQuery() {
    // Niet per se de input die wij focussen houdt de vorige term vast: op /search
    // staat hij in de zichtbare desktop-input en in het zoekformulier.
    var held = null, list = boundSearchInputs();
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent && list[i].value) { held = list[i]; break; }
    }
    if (!held) return;
    var start = held.value, tries = 0;
    (function step() {
      var el = document.activeElement;
      // De fullscreen-laag neemt de focus over met een eigen input; die krijgt
      // dezelfde behandeling. Daarom kijken we naar wat er nu focus heeft.
      if (!el || el.tagName !== 'INPUT' || !el.value) el = held;
      try {
        if (el.value !== start) return;                 // klant typt al: afblijven
        if (el.selectionStart === el.selectionEnd) el.select();
      } catch (e) {}
      if (tries++ < 8) setTimeout(step, 60);            // circa 0,5s
    })();
  }

  function openViaBoundInput() {
    var inp = boundSearchInput();
    if (!inp) return false;
    try {
      inp.focus();
      inp.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
      inp.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
      inp.click();
      selectExistingQuery();
      return true;
    } catch (e) { return false; }
  }

  function interceptSecondaryTriggers() {
    document.addEventListener('click', function (e) {
      if (!html.classList.contains('doofinder-active')) return; // Doofinder uit → native dialoog (fallback)
      var t = e.target && e.target.closest ? e.target.closest('[data-open-search-dialog]') : null;
      if (!t) return;
      if (openViaBoundInput()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, true); // capture: vóór de native showModal-handler
  }

  function watch() {
    var deadline = Date.now() + (cfg.detectTimeoutMs || 8000);
    (function poll() {
      if (doofinderLoaded()) { activate(); return; }
      if (Date.now() >= deadline) return;
      setTimeout(poll, 250);
    })();
  }

  // AI Assistant openen vanaf elk element met [data-df-ai-open]
  //
  // Directe feedback tijdens het openen (kaizen 05-08-2026).
  // Bij een klik is de Doofinder-API vaak nog niet geladen; we pollen dan tot
  // circa 6 seconden. Zonder zichtbare reactie leest die klik als kapot en is
  // het de meest voorkomende dode klik op collectiepagina's (Amplitude,
  // 30-07 t/m 05-08). NN/g: boven 1 seconde heeft de gebruiker feedback nodig,
  // en een wachtanimatie maakt de wachttijd aantoonbaar draaglijker.
  var aiBusyEl = null;
  var aiBusyHideTimer = null;
  var aiBusyMaxTimer = null;
  var AI_BUSY_MAX_MS = 12000; // harde bovengrens: de melding blijft nooit hangen

  function aiBusyStyles() {
    if (document.querySelector('style[data-df-ai-busy-style]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-df-ai-busy-style', '');
    st.textContent =
      '@keyframes dfAiBusySpin{to{transform:rotate(360deg)}}' +
      '#df-ai-busy{position:fixed;left:50%;bottom:20px;transform:translateX(-50%);' +
      'z-index:2147483000;display:flex;align-items:center;gap:10px;' +
      'max-width:calc(100vw - 32px);padding:12px 18px;border-radius:14px;' +
      'background:#0b1e36;color:#fff;font-size:14px;font-weight:600;line-height:1.35;' +
      'box-shadow:0 10px 28px rgba(11,30,54,.3)}' +
      '#df-ai-busy span{display:block}' +
      '#df-ai-busy i{width:16px;height:16px;flex:0 0 16px;border-radius:50%;display:block;' +
      'border:2px solid rgba(255,255,255,.35);border-top-color:#fff;' +
      'animation:dfAiBusySpin .7s linear infinite}' +
      '@media (prefers-reduced-motion:reduce){#df-ai-busy i{animation-duration:2.4s}}';
    document.head.appendChild(st);
  }

  function aiBusyShow(text, spinning) {
    try {
      aiBusyStyles();
      if (aiBusyHideTimer) { clearTimeout(aiBusyHideTimer); aiBusyHideTimer = null; }
      if (aiBusyMaxTimer) { clearTimeout(aiBusyMaxTimer); }
      aiBusyMaxTimer = setTimeout(function () { aiBusyHide(); }, AI_BUSY_MAX_MS);
      if (!aiBusyEl || !aiBusyEl.parentNode) {
        aiBusyEl = document.createElement('div');
        aiBusyEl.id = 'df-ai-busy';
        aiBusyEl.setAttribute('role', 'status');
        aiBusyEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(aiBusyEl);
      }
      aiBusyEl.innerHTML = (spinning ? '<i></i>' : '') + '<span></span>';
      aiBusyEl.querySelector('span').textContent = text;
    } catch (e) {}
  }

  function aiBusyHide(delay) {
    try {
      if (aiBusyHideTimer) { clearTimeout(aiBusyHideTimer); aiBusyHideTimer = null; }
      var kill = function () {
        if (aiBusyMaxTimer) { clearTimeout(aiBusyMaxTimer); aiBusyMaxTimer = null; }
        var stale = document.getElementById('df-ai-busy');
        if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
        aiBusyEl = null;
      };
      if (delay) { aiBusyHideTimer = setTimeout(kill, delay); } else { kill(); }
    } catch (e) {}
  }

  function openAiAssistant() {
    function aiReady() {
      return !!(window.Doofinder && Doofinder.AI && Doofinder.AI.Assistant && typeof Doofinder.AI.Assistant.open === 'function');
    }
    function fireOpen() {
      try {
        Doofinder.AI.Assistant.open();
        aiBusyHide();
        if (typeof gtag === 'function') gtag('event', 'ai_assistant_open', { event_category: 'Doofinder AI' });
        return true;
      } catch (e) { return false; }
    }
    if (aiReady()) return fireOpen();
    // API nog niet geladen: blijf kort proberen i.p.v. (verwarrend) de zoeklayer openen.
    // Toon meteen dat er iets gebeurt, anders is de klik tot 6 seconden lang stil.
    aiBusyShow('Vijverhulp wordt geopend', true);
    var tries = 0;
    (function poll() {
      if (aiReady()) { if (!fireOpen()) { aiBusyHide(); } return; }
      if (tries++ >= 30) { // ~6s laatste redmiddel
        aiBusyShow('Vijverhulp is nog niet geladen. Zoek zolang op product of merk.', false);
        aiBusyHide(5000);
        var inp = boundSearchInput();
        if (inp) { inp.focus(); inp.click(); selectExistingQuery(); }
        return;
      }
      setTimeout(poll, 200);
    })();
    return true;
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-df-ai-open]') : null;
    if (!t) return;
    e.preventDefault();
    // Sluit een open menu/zoek-dialoog zodat de AI-overlay niet erachter valt
    var dlg = t.closest('dialog');
    if (dlg && dlg.open && typeof dlg.close === 'function') { try { dlg.close(); } catch (e2) {} }
    // Sluit ook de cart-drawer (geen <dialog>; fullscreen op mobiel -> AI-overlay valt erachter)
    var cd = t.closest('cart-drawer');
    if (cd && typeof cd.close === 'function') { try { cd.close(); } catch (e3) {} }
    else if (window.CartDrawer && typeof window.CartDrawer.close === 'function' && t.closest('#cart-drawer')) { try { window.CartDrawer.close(); } catch (e4) {} }
    document.body.style.overflow = '';
    openAiAssistant();
  });

  interceptSecondaryTriggers();
  if (doofinderLoaded()) activate(); else watch();
})();

/**
 * Cart-drawer bridge v2 (2026-06-27)
 * ───────────────────────────────────────────────────────────────
 *  Doofinder (zoeklayer + AI Assistant) vuurt `doofinder.cart.add`
 *  (detail {item_id, amount}); item_id = Shopify variant-id. In onze setup
 *  voegt de Doofinder-plugin het product NIET zelf toe → wij doen de
 *  /cart/add.js, verversen de cart en openen de theme-drawer. CSS tilt de
 *  geopende drawer boven de Doofinder-overlay (mobiel).
 */
(function () {
  function openDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.CartDrawer && typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
    } catch (e) {}
  }
  document.addEventListener('doofinder.cart.add', function (e) {
    var d = (e && e.detail) || {};
    var id = d.item_id || d.id || d.variant_id;
    var qty = parseInt(d.amount, 10) || 1;
    if (!id) { openDrawer(); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
    .then(function (r) { return r.json().catch(function () { return {}; }); })
    .then(function () { openDrawer(); })
    .catch(function () { openDrawer(); });
    if (typeof gtag === 'function') { try { gtag('event', 'add_to_cart', { event_category: 'Doofinder' }); } catch (e2) {} }
  });
  try {
    var st = document.createElement('style');
    st.setAttribute('data-df-cart-fix', '');
    st.textContent = 'cart-drawer#cart-drawer[aria-hidden="false"]{z-index:2147483600!important}';
    document.head.appendChild(st);
  } catch (e) {}
})();
